import React, { createContext, useContext, useState , ReactNode, useEffect} from 'react';
import { RecipesRowType } from '../types/recipes';
import { useSorters } from './SorterContext';
import axios from 'axios';
import api from "../api/axiosClient"

interface RecipeContextType {
  recipes: RecipesRowType[];
  addRecipe: (recipeName: string, sorter_id:number) => void;
  updateRecipe: (updated: RecipesRowType) => Promise<void>;
  deleteRecipe: (id: number) => void;
  duplRecipe: (name: string, num_hoppers: number, sorter_color_model_id:number, sorter_recycling_model_id:number, sorter_reuse_model_id:number) => void
}

interface RecipeProviderProps {
  children: ReactNode;
}

const RecipeContext = createContext<RecipeContextType | undefined>(undefined);
export const useRecipes = (): RecipeContextType => {
  const context = useContext(RecipeContext);
  if (!context) {
    throw new Error("useRecipes must be used within a RecipeProvider");
  }
  return context;
};




export const RecipeProvider = ({ children }: RecipeProviderProps) => {
  const [recipes, setRecipes] = useState<RecipesRowType[]>([]);
  const {sorters} = useSorters();
  

  useEffect(() => {
    const fetchRecipes = async () => {
      try {
        const response = await api.get(`/sorter/recipe`);
        setRecipes(response.data);
      } catch (error) {
        console.error("Error fetching recipes:", error);
        setRecipes([])
      }};
       fetchRecipes();
      }, []);
  

  const updateRecipe = async (updated:RecipesRowType) => {
    await api.put(`/sorter/recipe/update/${updated.id}`, updated);
    setRecipes(prev =>
      prev.map(item => item.id === updated.id ? updated : item)
    );
  };

  const addRecipe = async (name: string, sorter_id:number) => {
    const sorter = sorters.find( sorter => sorter.id === sorter_id)
    const newRecipeDB = {
      id: sorter_id,
      name:name
    }

    const response = await api.post(`/sorter/recipe/create-from-sorter`, newRecipeDB)
    
    const newRecipe = {
      id: response.data.id,
      name: name,
      num_hoppers: sorter?.num_hoppers || 0,
      sorter_color_model_id: sorter?.sorter_color_model_id || -1,
      sorter_recycling_model_id: sorter?.sorter_recycling_model_id || -1,
      sorter_reuse_model_id: sorter?.sorter_reuse_model_id || -1,
      updated_at: new Date() 
    };
    setRecipes(prev => [...prev, newRecipe]);
    return newRecipe.id;
  };

  const duplRecipe =  async( name: string, num_hoppers: number, sorter_color_model_id:number, sorter_recycling_model_id:number, sorter_reuse_model_id:number) =>{
      const newRecipeDB = {
          name:name,
          num_hoppers: num_hoppers || 0,
          sorter_color_model_id: sorter_color_model_id || -1,
          sorter_recycling_model_id: sorter_recycling_model_id || -1,
          sorter_reuse_model_id: sorter_reuse_model_id || -1,
          updated_at: new Date() 
        }

      
      const response = await api.post(`/sorter/recipe/create`, newRecipeDB)
      const newRecipe = {
          id: response.data.id,
          name: name,
          num_hoppers: num_hoppers || 0,
          sorter_color_model_id: sorter_color_model_id || -1,
          sorter_recycling_model_id: sorter_recycling_model_id || -1,
          sorter_reuse_model_id: sorter_reuse_model_id || -1,
          updated_at: new Date() 
        };

      setRecipes(prev => [...prev, newRecipe]);
      return newRecipe.id;

  }



  const deleteRecipe = (id:number) => {
    const deleteRecipesDB = async () => {
      try {
        const response = await api.delete(`/sorter/recipe/delete/${id}`);
      } catch (error) {
        console.error("Error deleting recipe", error);
      }};
    
    deleteRecipesDB();
    setRecipes(prev => prev.filter(recipe => recipe.id !== id));
  };

  return (
    <RecipeContext.Provider value={{ recipes, addRecipe, updateRecipe, deleteRecipe, duplRecipe}}>
      {children}
    </RecipeContext.Provider>
  );
};
